import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { formatDate } from '@/lib/formatUtils';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  isViewDisabled?: boolean;
  onSearchClick?: () => void;
  onPrintClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportClick?: () => void;
  onEditPrintClick?: () => void;
  searchParams?: MuaHangRecord;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  isViewDisabled = false,
  onSearchClick,
  onPrintClick,
  onFixedColumnsClick,
  onRefreshClick,
  onExportClick,
  onEditPrintClick,
  searchParams
}) => (
  <ActionBarV2
    titleComponent={
      <div>
        <h1 className='text-xl font-bold'>Bảng kê chi tiết trả tiền cho các hoá đơn</h1>
        <span className='flex items-center justify-start text-xs font-semibold text-gray-500'>
          <div className='mr-2 size-2 rounded-full bg-red-500' />
          Từ ngày {formatDate(searchParams?.ngay_ct1)} đến ngày {formatDate(searchParams?.ngay_ct2)}
        </span>
      </div>
    }
  >
    {onSearchClick && <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} />}
    {onPrintClick && (
      <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrintClick} disabled={isViewDisabled} />
    )}
    {onRefreshClick && (
      <ActionButtonV2
        icon={RefreshCircle1ClockwiseStroke}
        title='Refresh'
        onClick={onRefreshClick}
        disabled={isViewDisabled}
      />
    )}
    {onFixedColumnsClick && (
      <ActionButtonV2
        icon={SignPostLeftStroke}
        title='Cố định cột'
        onClick={onFixedColumnsClick}
        disabled={isViewDisabled}
      />
    )}
    {onExportClick && (
      <ActionButtonV2
        icon={Download1Stroke}
        title='Kết xuất dữ liệu'
        onClick={onExportClick}
        disabled={isViewDisabled}
      />
    )}

    <MenuButtonV2
      items={[
        {
          title: 'Chỉnh sửa mẫu in',
          icon: <AritoIcon icon={864} />,
          onClick: onEditPrintClick,
          group: 0
        }
      ]}
    />
  </ActionBarV2>
);

export default ActionBar;
